import { IDataProviderFilter, IFilter, Logic } from 'core-components/types'
import { isInstanceOf } from 'core/utils/functions'

export const isFilter = (filter: IDataProviderFilter | IFilter): filter is IFilter =>
  isInstanceOf<IFilter>(filter, (obj) => 'field' in obj && 'value' in obj)

export const isDataProviderFilter = (
  filter: IDataProviderFilter | IFilter
): filter is IDataProviderFilter =>
  isInstanceOf<IDataProviderFilter>(filter, (obj) => 'logic' in obj && 'filters' in obj) &&
  Object.values(Logic).includes(filter.logic) &&
  Array.isArray(filter.filters)
